export const getIsCookieBannerShowing = () => {
  return (
    document.getElementById("onetrust-banner-sdk")?.style.visibility === ""
  );
};
